import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as CC from '../common/constants'
import * as C from './constants'

export const initialState = {
  isBot: false,
  meta: {
    cartName: '', // previously name
    ...createAsyncObject({})
  },
  scripts: createAsyncObject([]),
  trackers: createAsyncObject([])
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case CC.CHANGE_CART_NAME:
      draftState.meta.cartName = action.payload.name
      draftState.meta.fetched = false
      break
    case C.GET_SHOPPING_CART_META_REQUEST: updateForAsyncRequest(draftState.meta); break
    case C.GET_SHOPPING_CART_META_SUCCESS: updateForAsyncSuccess(action.payload.meta)(draftState.meta); break
    case C.GET_SHOPPING_CART_META_FAILURE: updateForAsyncFailure(action)(draftState.meta); break
    case C.GET_TRACKERS_REQUEST: updateForAsyncRequest(draftState.trackers); break
    case C.GET_TRACKERS_SUCCESS: updateForAsyncSuccess(action.payload.data)(draftState.trackers); break
    case C.GET_TRACKERS_FAILURE: updateForAsyncFailure(action)(draftState.trackers); break
    case C.GET_SCRIPTS_REQUEST: updateForAsyncRequest(draftState.scripts); break
    case C.GET_SCRIPTS_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.scripts); break
    case C.GET_SCRIPTS_FAILURE: updateForAsyncFailure(action)(draftState.scripts); break
    case C.SET_BOT_META: draftState.isBot = action.payload.isBot; break
    case C.GET_ADDRESS_FORMAT_REQUEST: draftState.meta.data.checkoutAddressFormat = draftState.meta.data.checkoutAddressFormat || {}; break
    case C.GET_ADDRESS_FORMAT_SUCCESS: draftState.meta.data.checkoutAddressFormat = ({ ...draftState.meta.data.checkoutAddressFormat, ...action.payload }); break
    case C.GET_ADDRESS_FORMAT_FAILURE: draftState.meta.data.checkoutAddressFormat = draftState.meta.data.checkoutAddressFormat || {}; break
    case C.GET_MENU_FEATURES_REQUEST: draftState.meta.data.features = draftState.meta.data.features || {}; break
    case C.GET_MENU_FEATURES_SUCCESS: draftState.meta.data.features = ({ ...draftState.meta.data.features, ...action.payload }); break
    case C.GET_MENU_FEATURES_FAILURE: draftState.meta.data.features = draftState.meta.data.features || {}; break
    case C.GET_STRIPE_TOKEN_REQUEST: draftState.meta.data.stripeToken = null; break
    case C.GET_STRIPE_TOKEN_SUCCESS: draftState.meta.data.stripeToken = action.payload.stripeToken; break
    case C.GET_STRIPE_TOKEN_FAILURE: draftState.meta.data.stripeToken = null; break
  }
})
